/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Enumerates the option for how row selection is animated.
 */
export var RowSelectionAnimationMode = /*@__PURE__*/ (function (RowSelectionAnimationMode) {
    /**
     * The correct animation mode is automatically selected.
     */
    RowSelectionAnimationMode[RowSelectionAnimationMode["Auto"] = 0] = "Auto";
    /**
     * No animation is performed.
     */
    RowSelectionAnimationMode[RowSelectionAnimationMode["None"] = 1] = "None";
    /**
     * The selection color and the normal background color are blended between.
     */
    RowSelectionAnimationMode[RowSelectionAnimationMode["ColorBlend"] = 2] = "ColorBlend";
    return RowSelectionAnimationMode;
})({});
/**
 * @hidden
 */
export var RowSelectionAnimationMode_$type = /*@__PURE__*/ markEnum('RowSelectionAnimationMode', 'Auto,0|None,1|ColorBlend,2');
//# sourceMappingURL=RowSelectionAnimationMode.js.map
